/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import { Component } from 'react';

import UserItem from './UserItem';

class UserList extends Component {
  state = {
    select_all: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { users } = this.props;

    if (nextProps.users !== users) {
      this.setState({ select_all: false });
    }
  }

  handleSelectAllClick = () => {
    const { handleSelectAllClick } = this.props;

    this.setState(
      (prevState) => ({ select_all: !prevState.select_all }),
      () => {
        handleSelectAllClick(this.state.select_all);
      },
    );
  };

  handleScroll = () => {
    const { handleRefreshSelectedUsers, triggerSearch, type } = this.props;

    if (
      this.list.scrollTop + this.list.clientHeight >=
      this.list.scrollHeight - 1000
    ) {
      if (type === 'selected') {
        handleRefreshSelectedUsers();
      } else {
        triggerSearch();
      }
    }
  };

  renderHeader = () => {
    const { total_users, type, users } = this.props;
    const { select_all } = this.state;

    if (type === 'selected') {
      return null;
    }

    return (
      <div className="flexbox soft-half">
        <div className="flexbox__item weight--semibold">
          {I18n.t('web.targeting_module.users_found', {
            nb: total_users,
            count: total_users,
          })}
        </div>
        {users.length > 1 && (
          <div className="flexbox__item text--right">
            <a onClick={this.handleSelectAllClick} role="button">
              {select_all
                ? I18n.t('actions.unselect_all')
                : I18n.t('actions.select_all')}
            </a>
          </div>
        )}
      </div>
    );
  };

  renderUsers = () => {
    const {
      can_select_user,
      type,
      defaultSelectedUsersIds,
      handleSelectUserClick,
      selected_user_ids,
      users,
    } = this.props;

    return users.map((user) => {
      let checked = false;

      if (
        type !== 'selected' &&
        selected_user_ids.find((user_id) => user_id === user.id)
      ) {
        checked = true;
      }

      return (
        <UserItem
          key={type ? `${type}-${user.id}` : user.id}
          user={user}
          checked={checked}
          handleSelectUserClick={handleSelectUserClick}
          type={type}
          cantSelect={!can_select_user && !checked}
          isFrozen={defaultSelectedUsersIds.indexOf(user.id) > -1}
        />
      );
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div
        className={`user-targeting-list ${classes}`}
        onScroll={this.handleScroll}
        ref={(ref) => (this.list = ref)}
        style={{ paddingRight: 0 }}
      >
        {this.renderHeader()}
        {this.renderUsers()}
      </div>
    );
  }
}

UserList.propTypes = {
  can_select_user: PropTypes.bool,
  classes: PropTypes.string,
  defaultSelectedUsersIds: PropTypes.array,
  handleSelectAllClick: PropTypes.func,
};

UserList.defaultProps = {
  can_select_user: false,
  classes: '',
  defaultSelectedUsersIds: [],
};

export default UserList;
